import { FsAdvancedMarker } from 'libs/geo/google/map/src';
import { SnLonLat } from 'libs/geo/helpers/src';

import { SnVerkadaCamera } from '../types';

export class VerkadaCameraMarker extends FsAdvancedMarker {
  public readonly camera: SnVerkadaCamera;
  public readonly isVerkadaCloudToCloud: boolean = true;

  constructor(camera: SnVerkadaCamera) {
    super({
      position: { lat: camera.locationLat, lng: camera.locationLon },
      title: camera.name,
      content: VerkadaCameraMarker._createMarkerElement(),
      gmpClickable: true,
      zIndex: 1000,
    });
    this.camera = camera;
  }

  private static _createMarkerElement(): HTMLElement {
    const element = document.createElement('img');
    element.src = '/assets/map-icons/CameraUp.png';
    element.style.width = '24px';
    element.style.height = '24px';
    element.style.cursor = 'pointer';
    element.style.transform = 'rotate(90deg)';
    return element;
  }

  public override getLonLat(): SnLonLat {
    return new SnLonLat(this.camera.locationLon, this.camera.locationLat);
  }
}
